import { h } from "omi";

import { IconProps } from "../icons";

export function CheckboxTickIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" width={props.width} height={props.height} fill="none">
      <path d="M10 3L4.5 8.5L2 6" stroke="white" stroke-width="1.6666" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}
